// import 'bootstrap';
import './cookies';
import './lib/jquery.countTo';
import './lib/swiper.jquery.min';
import './adios.theme';
